@use '../../../design-tokens/typography/typography' as *;
@use '../../../components/custom-scroll/custom-scroll' as *;

@layer design-system {
  .markdownA {
    @include typography-v2-ui-xs;
    color: var(--text-soft);
  }

  .markdownTableContainer {
    overflow-x: auto;
    margin: 1em 0;
    @include custom-scroll-minimal;
  }

  .markdownTable {
    border-spacing: 1px;
    width: 100%;

    tr {
      background-color: var(--background-default);
    }

    td {
      border-bottom: 1px solid var(--border-soft);
    }

    tbody tr:hover {
      background-color: var(--surface-hover);
    }
  }

  .truncatedCell {
    display: block;
    max-width: 480px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
